import * as React from 'react';
import { format } from 'date-fns';
import { useIntl } from 'react-intl';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material/';
import { IntlMessages } from '../util';
import { useMessages } from '../hooks/use-messages';
import { useBookingContext } from '../hooks/use-booking-context';

const HistoryTable: React.FC = () => {
  const intl = useIntl();
  const { recordLocator, bookingSource } = useBookingContext();
  const { messageServiceItems } = useMessages({ recordLocator, bookingSource });

  return (
    <TableContainer component={Paper}>
      <Table style={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <IntlMessages id="menu.createdAt" />
            </TableCell>
            <TableCell>
              <IntlMessages id="menu.createdBy" />
            </TableCell>
            <TableCell>
              <IntlMessages id="menu.action" />
            </TableCell>
            <TableCell>
              <IntlMessages id="menu.status" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {messageServiceItems?.map((m) => (
            <TableRow key={m.itemKey ?? `${m.createdAt}-${m.action}`}>
              <TableCell component="th" scope="row">
                <strong>{m.createdAt ? format(new Date(m.createdAt), 'dd.MM.yyyy HH:mm') : null}</strong>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="primary" align="left">
                  {m.createdBy}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body1" color="primary" align="left">
                  {intl.formatMessage({ id: `bookingDetailCard.history.action.${m.action}`, defaultMessage: m.action })}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="primary" align="left">
                  {intl.formatMessage({ id: `bookingDetailCard.history.status.${m.status}`, defaultMessage: m.status })}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HistoryTable;
